function calcular_frete(){
    
    var postalCode = $('#minicart_billing_cep').val(); 

    if (postalCode === '') {
        $('.resultado-frete').html('');
        return;
    }

    // Requisição à API ViaCEP para buscar o estado e outros detalhes
    $.ajax({
        url: `https://viacep.com.br/ws/${postalCode}/json/`,
        type: 'GET',
        dataType: 'json',
        success: function(response) {
            if (response.erro) {
                return;
            }

            var country = 'BR';
            var province = response.uf;

            // Atualizar região da barra de frete grátis (ViaCEP retorna "regiao": "Sudeste", etc.)
            var cepLimpo = String(postalCode).replace(/\D/g, '');
            if (cepLimpo.length >= 8) {
                try {
                    localStorage.setItem('minicart_last_cep', cepLimpo);
                    if (window.FreteRegional && response.regiao) {
                        window.FreteRegional.setRegiaoFromCep(response.regiao);
                    }
                } catch (e) {}
            }

            // Requisição ao Shopify para calcular o frete
            $.ajax({
                url: '/cart/shipping_rates.json',
                type: 'GET',
                data: {
                    'shipping_address[zip]': postalCode,
                    'shipping_address[country]': country,
                    'shipping_address[province]': province
                },
                beforeSend: () => {
                    $('.minicart-totais').addClass('waiting');
                },
                success: function(data) {
                    
                    var rates = data.shipping_rates;
                    var resultHtml = '';

                    if (rates.length > 0) {

                        $.each(rates, function(index, rate) {
                            if(rate.price){
                                resultHtml += '<p><span class="rate-name">' + rate.name + ':</span> R$ ' + rate.price + ' - <span class="rate-days">'+rate.delivery_days[0]+' dias úteis</span></p>';
                            }
                        });

                    } else {
                        var resultHtml = '<p>Não foi possível calcular o frete.</p>';
                    }
                    $('.minicart-totais').removeClass('waiting');
                    $('.resultado-frete').html(resultHtml);
                }
            });
        },
        error: function() {
            //alert('Erro ao consultar o CEP. Por favor, tente novamente.');
            $('.minicart-totais').removeClass('waiting');
        }
    });

}